'use client';

import { ButtonLink } from './ButtonLink';
import { START_ULTRAMETABOLIC_LINK } from './constants';
import { useChat } from 'react-live-chat-loader';
import { useForwardSearchParams } from '../../utils/useForwardSearchParams';
import { useTranslations } from 'next-intl';
import styles from './BottomOverlay.module.css';

export const BottomOverlay = ({
  reqiestAccessLink,
}: {
  hideBookCallBtn?: boolean;
  reqiestAccessLink?: string;
}) => {
  const t = useTranslations('common');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, loadChat] = useChat();
  const forwardSearchParams = useForwardSearchParams();

  return (
    <div className={styles.container}>
      <div className={styles.column}>
        <ButtonLink
          href={forwardSearchParams(
            reqiestAccessLink ?? START_ULTRAMETABOLIC_LINK,
          )}
          rel="noopener noreferrer"
          size="m"
          className={styles.button}
        >
          {t('bottomOverlay.buttonLink.orderNow')}
        </ButtonLink>
      </div>
    </div>
  );
};
